export const environment = {
  production: false,
  homologacao: false,
  desenvolvimento: true,
  CLIENT_ID: 'portal-assistente-digital',
  BASE_URL_API_KEYCLOAK: 'https://keycloak-dev.7care.com.br:8443',
  URL_CHAT_WIDGET:
    'https://dev-assistentedigital-middleware-ia-api.7care.com.br/componente/assistente-digital',
  moduloApiUrl: 'https://dev-gestaousuarios-api.7care.com.br',
  painelAdministrativoUrl: 'https://dev-gestaousuarios.7care.com.br',
  // painelAdministrativoUrl: 'http://localhost:4201',
  // moduloApiUrl: 'http://localhost:5167',
};
